import { useSelector } from "react-redux";
import { useOnline } from "../hooks/use-online";
import { selectGroupLoadedAt } from "../redux/reducer/app-slice";
import { offlineBannerText } from "../utils/offline-banner";

const OfflineBanner = () => {
  const online = useOnline();
  const loadedAt = useSelector(selectGroupLoadedAt);

  return (
    <div className="offline-banner-slot">
      {!online && (
        <div className="offline-banner" role="status">
          {offlineBannerText(loadedAt)}
        </div>
      )}
    </div>
  );
};

export default OfflineBanner;
